module.exports = __webpack_public_path__ + "img/man.5b89454e.png";